/* eslint-disable arrow-body-style */
import axios from 'axios';
import toast from 'react-hot-toast';

const Requester = async (config) => axios.request(config).then((response) => {
  const { data, status } = response;
  if (status === 200) {
    return data;
  } if (status === 204) {
    return data === '' || true;
  }
  return response;
}).catch((error) => {
  try {
    const { response: { data = '', status = 0 } = {}, request } = error;
    if (status || data) {
      if (status === 401) {
        toast.error(data.message || 'Bir hata oluştu');
        localStorage.removeItem('user');
        window.location.href = '/login';
      } else if (status === 500 || status === 422) {
        toast.error(data || 'Bir hata oluştu');
      } else {
        toast.error(data.message || 'Bir hata oluştu');
      }
    } else if (request) {
      console.log(request);
      toast.error(request.message || 'Bir hata oluştu');
    } else {
      console.log('Error', error.message);
      toast.error(error.message || 'Bir hata oluştu');
    }
    console.log(error.config);
  } catch (error2) {
    toast.error(error.message);
    console.log(error2);
  }

  return null;
});

export default Requester;
